var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{on:{"click":function($event){return _vm.showMenu()}}},[_c('baseIcon',[_c('menuIcon',{attrs:{"icon-color":_vm.$vuetify.theme.sz_grafit}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }